import { useFeatureFlags } from "../../query/hooks/useFeatureFlags";

/**
 * Gates the Stripe SetupIntent 3DS step run when a card is added.
 *
 * No anonymous counterpart flag: the SetupIntent endpoint resolves the payer
 * from the authenticated session, so the step only applies to signed-in payers.
 */
export const useIsStripe3dsCardSetupEnabled = (): boolean => {
  const queryFeatureFlags = useFeatureFlags();

  return !!queryFeatureFlags.data?.stripe3dsCardSetup;
};
